/**
 * Schema Markup Generator for SEO
 * Creates JSON-LD structured data for better search engine understanding
 */

const baseUrl = "https://www.ceekayenterprise.com";

/**
 * Organization Schema
 */
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Ceekay Enterprise",
  alternateName: "Ceekay Enterprise Chemical Suppliers",
  url: baseUrl,
  logo: `${baseUrl}/ceekay-logo.png`,
  description:
    "Leading importer and supplier of high-quality industrial chemicals and specialty products in India since 1992.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "215, Reena Complex, Ramdev Pir Rd, opp Neelkanth Corporate Park, Vidyavihar West",
    addressLocality: "Mumbai",
    addressRegion: "Maharashtra",
    postalCode: "400086",
    addressCountry: "IN",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-9322629818",
    contactType: "Customer Service",
    areaServed: "IN",
    availableLanguage: ["en", "hi"],
  },
  sameAs: [
    // Add social media profiles if available
  ],
  foundingDate: "1992",
  numberOfEmployees: {
    "@type": "QuantitativeValue",
    value: "10-50",
  },
};

/**
 * LocalBusiness Schema
 */
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${baseUrl}#organization`,
  name: "Ceekay Enterprise",
  image: `${baseUrl}/ceekay-logo.png`,
  description:
    "Industrial chemical importer and distributor in Mumbai, India. Specializing in borates, sulfates, nitrates, and specialty chemicals for construction, textiles, agriculture, and manufacturing industries.",
  url: baseUrl,
  telephone: "+91-9322629818",
  email: "ceekayent@yahoo.com",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    streetAddress: "215, Reena Complex, Ramdev Pir Rd, opp Neelkanth Corporate Park, Vidyavihar West",
    addressLocality: "Mumbai",
    addressRegion: "Maharashtra",
    postalCode: "400086",
    addressCountry: "IN",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "19.0760", // Mumbai approximate coordinates
    longitude: "72.8777",
  },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "09:00",
    closes: "18:00",
  },
  servesCuisine: "Industrial Chemicals",
  areaServed: {
    "@type": "Country",
    name: "India",
  },
};

/**
 * Product Schema Generator
 */
export const generateProductSchema = (product) => {
  const productSlug = product.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
  const productUrl = `${baseUrl}/products/${productSlug}`;

  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: product.name,
    description: product.description,
    image: product.image ? `${baseUrl}${product.image}` : `${baseUrl}/images/chemical-bags.jpg`,
    brand: {
      "@type": "Brand",
      name: "Ceekay Enterprise",
    },
    manufacturer: {
      "@type": "Organization",
      name: "Ceekay Enterprise",
    },
    offers: {
      "@type": "Offer",
      url: productUrl,
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      seller: {
        "@type": "Organization",
        name: "Ceekay Enterprise",
      },
      priceValidUntil: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      reviewCount: "150",
    },
    category: product.category || "Industrial Chemicals",
    sku: `CEEKAY-${product.id}`,
    mpn: product.name,
  };
};

/**
 * BreadcrumbList Schema Generator
 */
export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
};

/**
 * WebSite Schema with SearchAction
 */
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Ceekay Enterprise",
  url: baseUrl,
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${baseUrl}/search?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

/**
 * Service Schema
 */
export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Industrial Chemical Import and Distribution",
  provider: {
    "@type": "Organization",
    name: "Ceekay Enterprise",
  },
  areaServed: {
    "@type": "Country",
    name: "India",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Industrial Chemicals",
    itemListElement: [
      {
        "@type": "OfferCatalog",
        name: "Borates",
      },
      {
        "@type": "OfferCatalog",
        name: "Sulfates",
      },
      {
        "@type": "OfferCatalog",
        name: "Nitrates",
      },
      {
        "@type": "OfferCatalog",
        name: "Oxides",
      },
    ],
  },
};

